module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Thin.49689c08.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Thin.ttf
// module id = 2538
// module chunks = 7